var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrerequisites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "#EDE7F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.563 5.414c.234.211.234.563.023.797L5.898 8.086a.565.565 0 0 1-.398.164.446.446 0 0 1-.398-.164l-.938-.938c-.234-.21-.234-.562 0-.796.211-.211.563-.211.774 0l.539.539 1.289-1.454c.21-.234.562-.234.796-.023zm0 3.75c.234.211.234.563.023.797l-1.688 1.875A.565.565 0 0 1 5.5 12a.446.446 0 0 1-.398-.164l-.938-.938a.513.513 0 0 1 0-.773.513.513 0 0 1 .774 0l.539.516 1.289-1.454a.58.58 0 0 1 .796-.023zM9.25 6.75c0-.398.328-.75.75-.75h5.25c.398 0 .75.352.75.75 0 .422-.352.75-.75.75H10a.74.74 0 0 1-.75-.75zm0 3.75c0-.398.328-.75.75-.75h5.25c.398 0 .75.352.75.75 0 .422-.352.75-.75.75H10a.74.74 0 0 1-.75-.75zm-1.5 3.75c0-.398.328-.75.75-.75h6.75c.398 0 .75.352.75.75 0 .422-.352.75-.75.75H8.5a.74.74 0 0 1-.75-.75zm-2.625-1.125c.398 0 .75.234.96.563.212.351.212.796 0 1.124a1.122 1.122 0 0 1-1.945 0 1.079 1.079 0 0 1 0-1.124c.212-.329.563-.563.985-.563z",
    fill: "#7C4DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrerequisites);
export default __webpack_public_path__ + "static/media/prerequisites.48dda95a8b9e2b1520376825b1948f2e.svg";
export { ForwardRef as ReactComponent };